import AppEvents from 'Shared/app-events';
import BaseViewModel from './baseViewModel';
import SearchApi from 'Api/search-api';
import ProductItemModel from 'Models/productItemModel';
import { RangeFilterModel, MultiSelectFilterModel, TreeSelectFilterModel } from 'Models/filterModel';

export class CategoryModel {
    constructor(data) {
        ko.mapping.fromJS(data, this.#mapping, this);
    }

    #mapping = {
        Categories: {
            key: options => options.Id,
            create: options => new CategoryModel(options.data)
        }
    }
}

export class BrandModel {
    constructor(data) {
        ko.mapping.fromJS(data, this.#mapping, this);
    }

    #mapping = {}
}

export class FlagModel {
    constructor(data) {
        ko.mapping.fromJS(data, this.#mapping, this);
    }

    #mapping = {}
}

class SearchResult {
    constructor(view) {
        this.view = view;

        ko.mapping.fromJS({} , this.#mapping, this);
    }

    update = data => {
        ko.mapping.fromJS(data, this);
    }

    #mapping = {
        Brands: {
            key: data => ko.utils.unwrapObservable(data.Id),
            create: options => new BrandModel(options.data)
        },
        Categories: {
            key: data => ko.utils.unwrapObservable(data.Id),
            create: options => new CategoryModel(options.data)
        },
        Filters: {
            key: data => ko.utils.unwrapObservable(data.FilterId),
            create: options => {
                switch (options.data.FilterType) {
                    case 0: return new TreeSelectFilterModel(options.data, this.view);
                    case 1: return new MultiSelectFilterModel(options.data, this.view);
                    case 2: return new MultiSelectFilterModel(options.data, this.view);
                    case 3: return new MultiSelectFilterModel(options.data, this.view);
                    case 4: return new RangeFilterModel(options.data, this.view);
                }
            }
        },
        Products: {
            //key: data => ko.utils.unwrapObservable(data.Id) + '_' + ko.utils.unwrapObservable(data.Variants[0].Id),
            create: options => new ProductItemModel(options.data)
        }
    }

    updating = false;

    Products = ko.observableArray([]);
    Categories = ko.observableArray([]);
    Brands = ko.observableArray([]);
    Filters = ko.observableArray([]);

    activeFilters = ko.pureComputed(() => this.Filters().filter(f => f.active()));
}

export default class BaseCatalogViewModel extends BaseViewModel {
    constructor() {
        super();

        window.addEventListener('popstate', (e) => {
            this.search();
        });
    }

    async loadPageTemplates() {
        await super.loadPageTemplates();

        await this.loadTemplates(requireOptions.globalOptions.templatePath, [
            "salesinfo-tpl",
            "measure-field-tpl",
            "stock-info-tpl",
            "stock-info-list-tpl",
            "stock-tpl",
            "stock-traffic-light-tpl",
            "traffic-light-tpl",
            "stock-container-tpl",
            "storage-list-tpl",
            "product-ids-tpl",
            "dl-item-tpl-h",
            "dl-item-tpl-v",
            "dl-item-tpl",
            "c-art-id-tpl",
            "shipping-info-tpl",
            "price-info-tpl"
        ]);
    }

    initControls() {
        super.initControls();
    }

    loading = ko.observable(false);
    searchResult = new SearchResult(this);
    page = ko.observable(1);

    async loadModel() {
        await super.loadModel();

        await this.search();
    }


    openFilter = (filter, e) => {
        AppEvents.emit("filter.show", filter);
    }

    searchParams() {
        return {};
    }

    search = async () => {
        let query = this.#convertSearchToObject();

        let data = Object.assign(this.searchParams(), query);

        this.loading(true);
        
        var result = await SearchApi.products(data);

        this.searchResult.update(result);
        this.replaceUrl();

        this.loading(false);
    }

    #convertSearchToObject() {
        const params = new URLSearchParams(location.search);
        const jsonObject = {};

        for (const [key, value] of params) {
            jsonObject[key] = value;
        }

        return jsonObject;
    }

    /*hasNext = ko.pureComputed(() => this.modelLoaded() && this.searchResult.TotalCount() > ((this.searchResult.PageIndex() + 1) * this.searchResult.PageSize()));*/

    loadPrev = async () => {
        if (this.searchResult.PageIndex() > 0) {
            this.searchResult.PageIndex(this.searchResult.PageIndex() + 1);

            let query = (location.search)
                ? JSON.parse('{"' + location.search.substring(1).replace(/&/g, '","').replace(/=/g, '":"') + '"}', (key, value) => key === "" ? value : decodeURIComponent(value))
                : {};

            let data = Object.assign(this.searchParams(), query);
            data.page = this.searchResult.PageIndex() + 1;

            this.loading(true);

            var result = await SearchApi.products(data);
            result.Products.map(x => new ProductModel(x))
                .forEach(x => this.searchResult.Products.push(x));

            this.loading(false);
        }
    }

    loadNext = async () => {
        let query = (location.search)
            ? JSON.parse('{"' + location.search.substring(1).replace(/&/g, '","').replace(/=/g, '":"') + '"}', (key, value) => key === "" ? value : decodeURIComponent(value))
            : {};

        let data = Object.assign(this.searchParams(), query);
        data.page = this.searchResult.PageIndex() +2;

        this.loading(true);

        var result = await SearchApi.products(data);

        result.Products.map(x => new ProductItemModel(x))
            .forEach(x => this.searchResult.Products.push(x));

        this.searchResult.PageIndex(result.PageIndex);

        this.loading(false);
    }

    loadAll = async () => {
        if (this.searchResult.TotalCount() > (this.searchResult.PageIndex() + 1 * this.searchResult.PageSize())) {
            this.searchResult.PageIndex(this.searchResult.PageIndex() + 1);

            let query = (location.search)
                ? JSON.parse('{"' + location.search.substring(1).replace(/&/g, '","').replace(/=/g, '":"') + '"}', (key, value) => key === "" ? value : decodeURIComponent(value))
                : {};

            let data = Object.assign(this.searchParams(), query);
            data.page = -1;

            this.loading(true);

            var result = await SearchApi.products(data);
            this.searchResult.Products.concat(result.Products.map(x => new ProductModel(x)))

            this.loading(false);
        }
    }


    filters = ko.pureComputed(this.searchResult.Filters);

    removeAllFilters() {
        let filter = this.searchParams();

        var params = new URLSearchParams(filter).toString();

        history.pushState(params, null, `${location.pathname}?${params}`);
        this.search();
    }

    update = () => {
        this.pushUrl();
        this.search();
    }

    pushUrl = () => {
        let filter = this.searchParams();
        this.searchResult.Filters()?.forEach(f => f.apply(filter));

        delete filter.categoryId;
        delete filter.brandId;

        var filterParams = new URLSearchParams(filter).toString();
        if (filterParams) {
            history.pushState(filter, null, `${location.pathname}?${filterParams}${location.hash}`);
        } else {
            history.pushState(null, null, location.pathname + location.hash);
        }
    }

    replaceUrl = () => {
        let filter = this.searchParams();
        this.searchResult.Filters()?.forEach(f => f.apply(filter));

        delete filter.categoryId;
        delete filter.brandId;

        var filterParams = new URLSearchParams(filter).toString();
        if (filterParams) {
            history.replaceState(filter, null, `${location.pathname}?${filterParams}${location.hash}`);
        } else {
            history.replaceState(null, null, location.pathname + location.hash);
        }
    }
}